export default {
  en: {
    back: 'Back',
  },
  ru: {
    back: 'Назад',
  },
  de: {
    back: 'Zurück',
  },
  pt: {
    back: 'Voltar',
  },
  fr: {
    back: 'Retour',
  },
  es: {
    back: 'Atrás',
  },
};
